import { Box } from '@mantine/core';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { StepperOnboardingFormValues } from '../../types';
import { formatStepperDisplayPhoneNumber } from '../../utils';
import StepperSetupCompleteActivationCard from './components/StepperSetupCompleteActivationCard';
import StepperSetupCompleteTestCallCard from './components/StepperSetupCompleteTestCallCard';

type StepperSetupCompletePanelProps = {
	isActivationPanelVisible: boolean;
	isTestCallModalVisible: boolean;
	isWaitingStatusVisible: boolean;
	onCloseTestCallModal: () => void;
};

const StepperSetupCompletePanel: FC<StepperSetupCompletePanelProps> = ({
	isActivationPanelVisible,
	isTestCallModalVisible,
	isWaitingStatusVisible,
	onCloseTestCallModal
}) => {
	const { control } = useFormContext<StepperOnboardingFormValues>();
	const agentName = useWatch({
		control,
		name: 'agentName'
	});
	const agentPhoneNumber = useWatch({
		control,
		name: 'agentPhoneNumber'
	});

	if (isTestCallModalVisible) {
		return (
			<Box className="mt-1.5">
				<StepperSetupCompleteTestCallCard
					displayedAgentPhoneNumber={formatStepperDisplayPhoneNumber(
						agentPhoneNumber ?? ''
					)}
					isWaitingStatusVisible={isWaitingStatusVisible}
					onClose={onCloseTestCallModal}
				/>
			</Box>
		);
	}

	if (isActivationPanelVisible) {
		return (
			<Box className="mt-1.5">
				<StepperSetupCompleteActivationCard
					agentName={agentName ?? ''}
					agentPhoneNumber={agentPhoneNumber ?? ''}
				/>
			</Box>
		);
	}

	return null;
};

export default StepperSetupCompletePanel;
